export const Constants = {
  AMWAY_HEADER_LOGO: `images/AmwayFullLogo-BlackNoTM.svg`,
  google: `icons/Google.png`,
  facebook: `images/Facebook.svg`,
  line: 'images/Line.svg',
  NOT_FOUND: 'images/Telescope.svg',
  apple: 'images/Apple.svg',
};
export enum PhoneDisplayFormat {
  NATIONAL = 'NATIONAL',
  INTERNATIONAL = 'INTERNATIONAL',
}

export const LOGIN_DATA = 'loginData';
export const MIGRATION_STEPS = 'migrationSteps';
export const CREATE_AMWAY_WITHOUT_PASSWORD = 'showChangeIdWithoutPassword';

export const CONTAINER_WIDTH = {
  MOBILE_WIDTH: '21.4375rem',
  DESKTOP_WIDTH: '36rem',
};
